import * as React from 'react'
import PropTypes from 'prop-types'
import { Field } from '@oakwood/formit'
import TextField from 'components/TextField'
import { useTranslations } from 'containers/Translations/TranslationsContext'
import { useAuth } from '../AuthContext'
import * as constants from '../constants'

const AuthCommonFields = React.memo(function AuthCommonFields(props) {
  const { screen } = props

  const { passwordPattern } = useAuth()
  const t = useTranslations()

  return (
    <>
      <Field
        component={TextField}
        name="email"
        label={t('Web.AuthCommon.Email')}
        type="text"
        margin="normal"
        fullWidth
        required
        autoFocus
        id="kalla-auth-login-email" // Makes `label` and `helperText` accessible for screen readers.
      />

      {screen !== constants.SCREEN_RECOVER_PASSWORD && (
        <Field
          component={TextField}
          name="password"
          label={t('Web.AuthCommon.Password')}
          type="password"
          margin="normal"
          fullWidth
          required
          id="kalla-auth-login-password" // Makes `label` and `helperText` accessible for screen readers.
          inputProps={{
            pattern: passwordPattern,
          }}
        />
      )}
    </>
  )
})

AuthCommonFields.propTypes = {
  screen: PropTypes.string.isRequired,
}

function AuthCommonFieldsContainer(props) {
  const { screen } = useAuth()

  return <AuthCommonFields screen={screen} {...props} />
}

export default AuthCommonFieldsContainer
